module.exports = "<empresa-clientes-lista\r\n    empresa-id=\"$ctrl.empresaId\"></empresa-clientes-lista>\r\n";


//////////////////
// WEBPACK FOOTER
// ./src/empresa/components/clientes/template.html
// module id = 2458
// module chunks = 0